export const ADMIN_SETTINGS_EVENTS = {
  SETTINGS_PAGE_OPENED: "Settings Page Opened",
  SETTING_CHANGED: "Setting Changed",
} as const
